import { first, isNil } from 'lodash';
import { unparse } from 'papaparse';

import { Field } from '@/explore/types';
import { flattenNestedList } from '@/explore/grouping';
import { formatNumber } from '@/explore/utils/format';

export const convertRecordsToCsv = (
  records: Record<string, any>[],
  fields: Field[],
  isTruncated = false,
) => {
  records = flattenNestedList(records);

  const firstRecord = first(records);
  if (firstRecord === undefined) {
    return '';
  }

  const headers = fields.map((field) => field.name);
  const valueRows = records.map((record) =>
    fields.map(({ key }) => {
      const value = record[key];
      if (isNil(value)) {
        return '';
      }

      if (Array.isArray(value) || typeof value === 'object') {
        return JSON.stringify(value);
      }

      return value;
    }),
  );

  const csv = unparse([headers, ...valueRows], {
    // TODO: Decide which values to wrap based on fields type, e.g. [false, false, true, ...]
    // See the `quotes` option for more details on the array format: https://www.papaparse.com/docs#json-to-csv
    quotes: true,
    columns: headers,
    quoteChar: '"',
    escapeChar: '"',
    newline: '\n',
  });
  const warningRow = [
    `"⚠️ Warning: This result set contains the first ${formatNumber(records.length)} records."`,
    ...Array(headers.length - 1).fill(''),
  ];
  return isTruncated ? warningRow.join(',') + '\n' + csv : csv;
};
